import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReceivingBranch from "./ReceivingBranch";
import { getAssignmentTransferTypes } from "Store/OrderManagement/AssignmentTransferTypes/AssignmentTransferTypesAction";
import TransferAction from "Store/Component/Transfer/TransferAction";
import { getCostCenterBySearchString } from "Store/Organization/CostCenters/CostCentersAction";
import { CONSTANTS } from "client/utils/constants";
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
interface IProps {
    asset?: any,
    setAssetDetailList?: any,
    assetDetailList?: any,
    validateReceivingCostCenter?: any,
    validate?: any
}
const ReceivingBranchContainer = (props: IProps) => {
    const {
        asset,
        setAssetDetailList,
        assetDetailList,
        validateReceivingCostCenter,
        validate
    } = props;

    const dispatch = useDispatch();

    const {
        costCenterBySearchDropDownList = [],
    }: any = useSelector((state?: any) => ({
        costCenterBySearchDropDownList: state.CostCentersReducer.costCenterBySearchDropDownList
    }));

    const ReceivingBranchFieldRef = useRef<any>([]);
    const [costCentersBySearchList, setCostCentersBySearchList] = useState([])

    const fieldFocus = () => {
        ReceivingBranchFieldRef.current[0]?.focus()
    }

    useEffect(() => {
        fieldFocus();
        setCostCentersBySearchList([])
    }, [])

    useEffect(() => {
        if (costCenterBySearchDropDownList?.length) {
            const costcenterDropdownListTemp = costCenterBySearchDropDownList?.map((item: any) => ({ ...item, label: item?.text }));
            setCostCentersBySearchList(costcenterDropdownListTemp);
        }
    }, [costCenterBySearchDropDownList])

    useEffect(() => {
        dispatch(getAssignmentTransferTypes());
    }, []);

    const onChangeCostCenter = (selectedItem: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        if (selectedItem?.value !== null) {
            ReceivingBranchFieldRef?.current[2]?.focus();
        }
        let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
        assetDetailListTemp.forEach((assetItem: any) => {
            if (assetItem.assetIndex === asset.assetIndex) {
                assetItem.receivingCostCenter = selectedItem;
                assetItem.receivingCostCenterError = validateReceivingCostCenter(assetItem);
                assetItem.isValid = validate(assetItem)?.isValid;
            }
        });
        setAssetDetailList(assetDetailListTemp);
    }

    const searchCostCenter = (value: any, action: any) => {
        if (action.action === "input-change") {
            dispatch(getCostCenterBySearchString(value))
        }
    };

    return (
        <ReceivingBranch
            onChangeCostCenter={onChangeCostCenter}
            asset={asset}
            ReceivingBranchFieldRef={ReceivingBranchFieldRef}
            searchCostCenter={searchCostCenter}
            costCentersBySearchList={costCentersBySearchList}
        />
    )
}

export default ReceivingBranchContainer;
